import React from "react";
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";
import { wordEllipsis } from "../../utils/strings";
import StarRatings from "react-star-ratings";

export default function Testimonials({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

  const settings = {
    infinite: true,
    speed: 500,
    fade: false,
    autoplaySpeed: 6000,
    autoplay: true,
    dots: true,
    draggable: !!isMobile,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: isMobile ? 1 : 3,
    centerMode: !!isMobile,
    centerPadding: isMobile ? 0 : undefined,
    cssEase: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
    variableWidth: isMobile ? true : undefined
  };

  return (
    <div id="testimonials">
      <div className="header">
        <div className="title">{content.title}</div>
        <div className="subtitle">{content.subtitle}</div>
      </div>
      <Slider {...settings}>
        {content.caseCards.map((card, index) => (
          <div className="contentContainer" key={index} to={card.linkUrl}>
            <StarRatings
              name="rating"
              rating={5}
              starDimension="18px"
              numberOfStars={5}
              starRatedColor="#282828"
              starSpacing="2px"
            />
            <div className="content">{wordEllipsis(card.content, isMobile ? 220 : 190)}</div>
            <div className="signature">
              <div className="authorContainer">
                <div className="author">{card.author}</div>
                <div className="location">{card.location}</div>
              </div>
              <div className="logo">
                <img src={card.logo.url} alt="logo" />
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
